import { hideMenu, toggleMobileMenu } from "./modules/toggleMobileMenu";
import Auth from "./modules/auth";

const windowWidth = window.innerWidth;
const header = document.querySelector(".header");
const navbarToggler = document.querySelector(".nav-toggler");
window.addEventListener("DOMContentLoaded", () => {
  navbarToggler && header && toggleMobileMenu(navbarToggler, header);
  new Auth();
});

window.addEventListener("load", () => {});

window.addEventListener("resize", () => {
  window.innerWidth != windowWidth &&
    window.innerWidth >= 769 &&
    navbarToggler.classList.contains("menu-open") &&
    hideMenu(navbarToggler, header);
});
